import {
  Card,
  Col,
  DatePicker,
  Empty,
  Flex,
  Layout,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { ApexOptions } from "apexcharts";
import { reportsTable } from "@configurations";
import ReactApexChart from "react-apexcharts";
import { useEffect, useState } from "react";
import { useGetReportByDate, useGetReportsDate } from "@hooks";
import { reportsPageGraph } from "./helpers";

export const ReportsPage = () => {
  const { t } = useTranslation();
  const [currentDate, setCurrentDate] = useState<string>("");
  const { data, isLoading } = useGetReportByDate(currentDate);
  const [chartPassageOptions, setChartPassageOptions] = useState<ApexOptions>(
    reportsPageGraph(t, data)
  );

  const {data: enabledDates, isLoading: datesLoading} = useGetReportsDate();

  useEffect(() => {
    if (data) {
      setChartPassageOptions(reportsPageGraph(t, data));
    }
  }, [data]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Layout>
        <div style={{ display: "flex", marginBottom: 12 }}>
          <div
            style={{
              width: 3,
              backgroundColor: "#F1B80E",
              borderRadius: 100,
              marginRight: 12,
            }}
          />
          <Typography.Title level={2} style={{ margin: 0 }}>
            {t("reports")}
          </Typography.Title>
        </div>
        <Space style={{ marginBottom: 12 }}>
          <DatePicker
            showNow={false}
            disabled={datesLoading}
            format={"DD.MM.YYYY"}
            width={300}
            disabledDate={(current) =>
              current && !enabledDates?.includes(current.format("YYYY-MM-DD"))
            }
            onChange={(date) => setCurrentDate(date.format("YYYY-MM-DD"))}
            // components={{
            //   date: (props) =>
            //     MyDatePanel(
            //       props,
            //       data?.map((item: any) => item.date)
            //     ),
            // }}
          />
        </Space>
        {currentDate.length > 0 ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            key={currentDate}
          >
            <Row gutter={16}>
              <Col span={18}>
                <div
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.16) 1px 0px 5px",
                    borderRadius: "8px",
                  }}
                >
                  <Table
                    rowKey={(record) => record.id}
                    size="middle"
                    dataSource={data}
                    loading={isLoading}
                    columns={reportsTable}
                  />
                </div>
              </Col>
              <Col span={6}>
                <Card loading={isLoading}>
                  <Flex justify="center">
                    <ReactApexChart
                      options={chartPassageOptions}
                      series={chartPassageOptions.series}
                      type="donut"
                      width={300}
                    />
                  </Flex>
                </Card>
              </Col>
            </Row>
          </motion.div>
        ) : (
          <Empty description={t("pages.reports.empty")} />
        )}
      </Layout>
    </motion.div>
  );
};
